<template>
  <div>
    <div v-if="onbording_filters" class="choosing_filter">
      <div class="container_filters">
        <div class="title">
          <h1 class="f-anti fs-24 fw-demi-bold mt-4 ls-2 lh-5">We’re fetching very fresh transfer fees and exchange rates for your comparison</h1>
          <h2 class="f-anti fs-34 fw-bold mt-3 ls-2 ">Let's use this short time-out to filter the futur results</h2>
           <a @click="closeOnbording" class="btn_cta fw-bold f-anti f-19 ls-1 pl-4 pr-4 pt-2 pb-2 fs-18 f-anti mt-6">Apply and continue</a>
        </div>
        <aside>
        <app-pick-payout v-if="info.results !== undefined" @changePayout="pickReceiving = $event" :pickReceiving="pickReceiving" :list_payout="list_payout"></app-pick-payout>
       <app-pick-interest :pickInterest="pickInterest" @changeInterest="pickInterest = $event"></app-pick-interest>
      <app-pick-payin :credit_card="credit_card" :debit_card="debit_card" :bank_transfer="bank_transfer" @changeDebitCard="debit_card = $event" @changeCreditCard="credit_card = $event" @changeBankTransfer="bank_transfer = $event"></app-pick-payin>
    </aside>
      </div>
     
    </div>
    <header>
      <app-navigation>
        <h1 id="logo_monito"><a href="https://monito.com">monito</a></h1>
        <ul>
          <li><a href="https://www.monito.com/en/about-monito">About us</a></li>
          <li><a href="https://www.monito.com/en/wiki/monito-account">Alerts</a></li>
          <li><a href="https://www.monito.com/en/wiki">Wiki</a></li>
          <li class="langage"><a href="#">EN</a></li>
        </ul>
      </app-navigation>

      <app-hero-section :herotype="herotype"></app-hero-section>
    </header>
    <transition name="apper" appear>
     <main ref="main">
      <section class="result shadow" ref="scroll_zone">
        <div class="color"></div>
        <h1 class="mb-3 pt-7">The best solutions to send money from the United States to the United Kingdom</h1>
        <h2 v-if="info.results !== undefined && !fake_loading" style="letter-spacing: 0.015em; margin: 0 auto; margin-top: 36px; margin-bottom: 10px; font-size: 22px; -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;text-align: center;" class="fw-bold f-anti">Sending <span style="color: #F53449; cursor: pointer;" @click="wantChangeAmount()">{{ virgule_amount_send(info.amount) }}</span> will get your recipient…</h2>
      <app-pick-interest v-if="info.results !== undefined" :pickInterest="pickInterest" @changeInterest="pickInterest = $event"></app-pick-interest>
      <app-loading v-if="info.results === undefined || fake_loading"></app-loading>

    

     <app-best-rated v-if="info.results !== undefined && bestView && !fake_loading" :info="info" :sortedArray="sortedArray" :getTransferScore="getTransferScore" :getLogoPsp="getLogoPsp" :getTransferBar="getTransferBar" :getPspName="getPspName" :virgule_rec="virgule_rec" :virgule="virgule" :getPspLink="getPspLink"></app-best-rated>

     <app-fast v-if="info.results !== undefined && fastView && !fake_loading" :sortedArray="sortedArray" :getTransferScore="getTransferScore" :getLogoPsp="getLogoPsp" :getTransferBar="getTransferBar" :getPspName="getPspName" :virgule_rec="virgule_rec" :virgule="virgule" :getPspLink="getPspLink"></app-fast>



      <transition-group name="flip-list" tag="ul" :class="['my_list','cheap_list']"  v-if="info.results !== undefined && cheapView && !fake_loading">
        <li 
          v-for="(result,index) in sortedArray" 
          :key="index+'_'+result.psp_id" 

          :class="['psp_'+result.psp_id, getTransferScore(result.costs.total_received_usd.toFixed(0)), {
            'debit': Object.keys(result.options.sending)[0]=='debit_card',
            'credit': Object.keys(result.options.sending)[0]=='credit_card',
            'bank': Object.keys(result.options.sending)[0]=='bank_transfer'
          }]"
        ><div class="container">
          <span class="logo_provider" :style="{backgroundImage: 'url('+ getLogoPsp(result.psp_id) +')'}"></span>
          <div class="container_amount">
            <div class="illustration_amount impact_green">
              <div :style="{width : getTransferBar(result.costs.total_received_destination.toFixed(0)),animationDelay: ''+(0.4 + ((index + 0.1) / 8))+'s'}" class="anim_element"></div> 
            </div>
          </div>
          <span class="amount" >
          {{ virgule_rec(result.costs.total_received_destination) }}</span>
          <span class="total_cost" style="font-weight: bold;  font-size: 14px; "><span>{{ virgule(result.costs.total_fees) }}</span></span>
          <a :href="getPspLink(result.psp_id)">Go to <span>{{ getPspName(result.psp_id) }}</span>  </a></div>
            <div class="details">
              <div class="container">
                <span v-if="false" style=" width: 100%; box-sizing: border-box; background: #1E2026; border-radius: 12px 12px 0 0 ; font-size: 12px; line-height: 16px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em;
                padding: 18px 20px;">About this transfer with {{ getPspName(result.psp_id) }}</span>
                <div>
                  <span style="font-size: 19px;margin-top: 24px;font-weight: 600; ">You pay</span>
                  <span style="
                    font-size: 23px; 
                    font-weight: 700; 
                  ">{{ virgule_amount_send(info.amount) }}</span>
                  <span class="boxed_info">{{ getPayinLabelBlack(Object.keys(result.options.sending)[0]) }}</span>
                </div>
                <div>
                  <span style="
                    font-size: 23px; 
                    font-weight: 700; 
                    letter-spacing: 0.035em; 
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                  ">{{ virgule_rec(result.costs.total_received_destination) }}</span>
                  <span style="font-size: 19px;margin-bottom: 6px; font-weight: 600; max-width: 75%;">arrives in the United Kingdom</span>
                  <span class="boxed_info clock">{{ getSpeedLabel(result.transfer_time_product_rate) }}</span>
                  <span class="boxed_info">{{ getPayoutLabelBlack(Object.keys(result.options.receiving)[0] )}}</span>
                  
                </div>
              </div>
            </div>
        </li>
      </transition-group>
      </section> 
      <section v-if="info.results !== undefined && !fake_loading" class="story result boxed shadow">
        <div class="color"></div>
        <h1 class="pt-10">{{ info.story[0] }}</h1>
        <p class="f_chapo" v-html="info.story[1]"></p>
        <p class="f_body" v-html="info.story[2]"></p>
        <p class="f_body" v-html="info.story[3]"></p>
        <p class="f_body" v-html="info.story[4]"></p>
        <p class="f_body" v-html="info.story[5]"></p>
        <p class="f_body" v-html="info.story[6]"></p>
        <p class="f_body" v-html="info.story[7]"></p>
      </section>
      <aside ref="scroll_widgets" v-if="info.results !== undefined && !fake_loading">
      <app-pick-payout @changePayout="pickReceiving = $event" :pickReceiving="pickReceiving" :list_payout="list_payout"></app-pick-payout>
      <app-pick-payin v-if="info.results !== undefined" :credit_card="credit_card" :debit_card="debit_card" :bank_transfer="bank_transfer" @changeDebitCard="debit_card = $event" @changeCreditCard="credit_card = $event" @changeBankTransfer="bank_transfer = $event"></app-pick-payin>

     
    </aside>
    </main>
    
    </transition>
     <widget-providers :providers="providers">
    <h1 class="fs-28 lh-6 mb-1 mt-5
      fs-sm-24 lh-sm-5  mb-sm-3 ls-sm-2
    ">We compare and review over 300 money transfer companies</h1>
    <span class="fs-19 italic fs-sm-17 fw-demi-bold f-anti" style="opacity: 0.88;">An easy way to find the good one</span>
  </widget-providers>
  <app-footer></app-footer>
  </div>

</template>

<script>
  import Loading from './Loading.vue'
  import Cheap from './Cheap.vue'
  import Fast from './Fast.vue'
  import BestRated from './BestRated.vue'
  import PickPayout from './PickPayout.vue'
  import PickInterest from './PickInterestFull.vue'
  import PickPayin from './PickPayin.vue'
  import axios from 'axios' 
  import Nav from './Nav.vue'
  import Hero from './Hero.vue'
  import WidgetProviders from './WidgetProviders.vue'
  import Footer from './Footer.vue'
export default {    
  data () {
    return {
      info: [],
      listsProvider : [],
      dataFetch : false,
      minimumLoading : true,
      fake_loading: false,
      onbording_filters :false,
      credit_card : true,
      debit_card : false,
      cheapView : true,
      fastView: false,
      bestView : false,
      minAmount : '',
      maxAmount : '',
      herotype : 'corridor',
      bank_transfer : true,
      pickReceiving : 'Bank transfer',
      pickInterest : 'cheap',
      scroll_zone : '0',
      providers : [
          {logo: '/public/review_ria.png',url:'ria.com',score:'5.8'},
          {logo: '/public/review_worldremit.png',url:'paypal.com',score:'8.3'},
          {logo: '/public/review_paypal.png',url:'paypal.com',score:'5.1'},
          {logo: '/public/review_remitly.png',url:'paypal.com',score:'7.6'},
          {logo: '/public/review_transfergo.png',url:'paypal.com',score:'8.2'},
          {logo: '/public/review_western.png',url:'paypal.com',score:'7.9'},
          {logo: '/public/review_transferwise.png',url:'paypal.com',score:'8.8'},
          {logo: '/public/review_xendpay.png',url:'paypal.com',score:'6.6'},
          {logo: '/public/review_skrill.png',url:'paypal.com',score:'8.3'}
        ],
    }
  },
  methods : { 
    closeOnbording(){
      this.onbording_filters = false,
      this.fake_loading = false
    },

    getSpeedLabel(speed){
      if( speed == '10'){
        return 'within minutes';
      }
      if( speed == '20'){
        return 'the same day';
      }
      if( speed == '30'){
        return 'the next day';
      }
      if( speed == '40'){
        return 'within 2 days';
      }
      if( speed == '50'){
        return 'within 3 to 5 days';
      }
    },
    getPayinLabelBlack(payin){
      if( payin == 'bank_transfer'){
        return 'by bank transfer';
      }
      if( payin == 'credit_card'){
        return 'by credit card';
      }
      if( payin == 'debit_card'){
        return 'by debit card';
      }
      
    },
    getPayoutLabelBlack(payout){
      if( payout == 'bank_account'){
        return 'to a bank account';
      }
      if( payout == 'cash_pickup'){
        return 'to a cash pick-up location';
      }
      return payout;
      
    },
    getTransferBar(amount){
      return (100 - (( this.max - amount) / ((this.max - this.min) / 100))) + '%';
    },
    getPspName(pspId){
      return this.info.psp_list.find(item => item.id == pspId).info.label 
    },
    getPspLink(pspId){
      return this.info.psp_list.find(item => item.id == pspId).links.external
    },
    getFrom(iso){
      return this.country.find(item => item.iso == iso).label.from
    },
    getTo(iso){
      return this.country.find(item => item.iso == iso).label.to
    },
    getLogoPsp(pspId){
      return this.info.psp_list.find(item => item.id == pspId).info.img.md 
    },
    virgule(value){
      return value.toFixed(2) + ' ' +this.info.corridor.currency_from.iso_code;
    },
    handleScroll(event){
      // hauteur de la zone de scroll
      //this.scroll_zone = this.$refs.scroll_zone.clientHeight;
      var bodyRect = document.body.getBoundingClientRect(),
      container_width = this.$refs.main.clientWidth,
      aside = this.$refs.scroll_widgets.getBoundingClientRect(),
      scroll_zone = this.$refs.scroll_zone.getBoundingClientRect(),
      left = scroll_zone.right,
      aside_width = this.$refs.scroll_widgets.clientWidth,
      scroll_zone_width = this.$refs.scroll_zone.clientWidth,
      aside_height = this.$refs.scroll_widgets.clientHeight,
      scroll_zone_height = this.$refs.main.clientHeight,
      

      hauteur_zone_scroll = this.$refs.scroll_zone.clientHeight,

      // position top de la zone de scroll
      offset_scroll_zone = scroll_zone.top - bodyRect.top;
      var position_x_aside = scroll_zone.top - bodyRect.top;

      var bottom_main_content = (offset_scroll_zone + scroll_zone_height);

      // valeur du scoll de la page
      var y = window.scrollY;
      var debut_scroll = 0;



   
        if(y > (position_x_aside + 30)){
          if(y <= (bottom_main_content - aside_height - 20)){
            this.$refs.scroll_widgets.style.position = 'fixed';
            this.$refs.scroll_widgets.style.left = left+(container_width - (scroll_zone_width + aside_width)) + 'px';
            this.$refs.scroll_widgets.style.top = 20 + 'px';
          } else {
            this.$refs.scroll_widgets.style.top = ((scroll_zone_height - aside_height)) + 'px';
            this.$refs.scroll_widgets.style.position = 'absolute';
            this.$refs.scroll_widgets.style.left = '';
          }
        } else {
          this.$refs.scroll_widgets.style.top = '50px';
          this.$refs.scroll_widgets.style.position = 'absolute';
          this.$refs.scroll_widgets.style.left = '';
        }
  
    },  

    getTransferScore(amount){
      function getBaseLog(x, y) {
        return Math.log(y) / Math.log(x);
      }
      if((((0.5/getBaseLog(1000,this.base_amount))*this.base_amount)/100)>=(this.base_amount - amount)){
        return'excellent';
      } else if ((((1.5/getBaseLog(1000,this.base_amount))*this.base_amount)/100)>=(this.base_amount - amount)){
        return 'good';
      } else if ((((2.5/getBaseLog(1000,this.base_amount))*this.base_amount)/100)>=(this.base_amount - amount)){
        return 'average';
      } else if ((((4/getBaseLog(1000,this.base_amount))*this.base_amount)/100)>=(this.base_amount - amount)){
        return 'poor';
      } else {
        return 'bad';
      }
    },
    
    virgule_rec(somme){
      somme = somme.toFixed(0)
      var cut = 3;
      if(somme.length > 6){
          var first_cut = somme.length - cut;
          var second_cut = (somme.length - cut)- cut;
          var start = somme.substring(0,second_cut);
          var middle = somme.substring(second_cut,first_cut);
          var end = somme.substring(first_cut,somme.length);
          somme = (''+start+','+middle+','+end+'');
          //somme = (''+start+','+end+'');
      } else if(somme.length > 3){
          var first_cut = somme.length - cut;
          var start = somme.substring(0,first_cut);
          var end = somme.substring((first_cut),somme.length);
          somme = (''+start+','+end+'');
          //somme = (''+start+','+end+'');
      }
       return somme  + ' ' + this.info.corridor.currency_to.iso_code;
    },
    virgule_amount_send(somme){
      somme = somme.toFixed(0)
      var cut = 3;
      if(somme.length > 6){
          var first_cut = somme.length - cut;
          var second_cut = (somme.length - cut)- cut;
          var start = somme.substring(0,second_cut);
          var middle = somme.substring(second_cut,first_cut);
          var end = somme.substring(first_cut,somme.length);
          somme = (''+start+','+middle+','+end+'');
          //somme = (''+start+','+end+'');
      } else if(somme.length > 3){
          var first_cut = somme.length - cut;
          var start = somme.substring(0,first_cut);
          var end = somme.substring((first_cut),somme.length);
          somme = (''+start+','+end+'');
          //somme = (''+start+','+end+'');
      }
       return somme  + ' ' + this.info.corridor.currency_from.iso_code;
    },
    premierProvider(pspId){
        if(this.listsProvider.indexOf(pspId) != -1){
        } else {
          this.listsProvider.push(pspId);
        } 
    },
    
    adapte(){
      if (this.pickInterest == 'cheap'){
        this.cheapView = true;
        this.fastView = false;
        this.bestView = false;
      }
      if (this.pickInterest == 'fast'){
        this.cheapView = false;
        this.fastView = true;
        this.bestView = false;
      }
      if (this.pickInterest == 'best'){
        this.cheapView = false;
        this.fastView = false;
        this.bestView = true;
      }
    },
    randomIndex: function () {
      return Math.floor(Math.random() * this.items.length)
    },
    amount(somme){
    },
    add: function () {
      this.items.splice(this.randomIndex(), 0, this.nextNum++)
    },
    remove: function () {
      this.items.splice(this.randomIndex(), 1)
    },
    shuffle: function () {
      this.items = _.shuffle(this.items)
    },
    test: function () {
      var johns = _.map(this.info.results, function(o) {
        if (o.psp_id == "3") return o;
      });
    }
  },
  components : {
    'app-loading' : Loading,
    'app-cheap' : Cheap,
    'app-fast' : Fast,
    'app-best-rated' : BestRated,
    'app-pick-payout' : PickPayout,
    'app-pick-interest' : PickInterest,
    'app-pick-payin' : PickPayin,
    'app-navigation' : Nav,
    'app-hero-section' : Hero,
    'widget-providers' : WidgetProviders,
    'app-footer' : Footer
  },
  watch : {
    pickInterest : 'adapte'
    
  },
  computed: {

    min(){
      var vm = this;
      function min(a, b) {
        if (a < b)
          return -1;  
        if (a >  b)
          return 1;
        return 0;
      }

      function amount(data) {
        var a = [];
        if (data !== undefined){
          for ( var i = 0; i < data.length; i++ ) {
            a.push(data[i].costs.total_received_destination.toFixed(2));
          }
        }
        return a;
      }
      return amount(this.info.results).sort(min)[0];
    },

    base_amount(){
      return this.info.amount_usd.toFixed(2)
    },

    max(){
      var vm = this;
      function max(a, b) {
        if (a > b)
          return -1;  
        if (a < b)
          return 1;
        return 0;
      }

      function amount(data) {
        var a = [];
        if (data !== undefined){
          for ( var i = 0; i < data.length; i++ ) {
            a.push(data[i].costs.total_received_destination.toFixed(0));
          }
        }
        return a;
      }
      return amount(this.info.results).sort(max)[0];
    },

    list_payout(){
      var vm = this;
      function keep_one_payout(data) {
        var a = [];
        if (data !== undefined){
          for ( var i = 0; i < data.length; i++ ) {
            if ( a.indexOf(Object.values(data[i].options.receiving)[0]) == '-1' ) {
              a.push(Object.values(data[i].options.receiving)[0]);
            }
          }
        }
        return a;
      }
      return keep_one_payout(this.info.results);
    },
    transferSpeed() {
      var vm = this;

        var a = [];
        for ( var i = 0; i < data.length; i++ ) {
          if ( data[i].transfer_time_product_rate == speed) {
            a.push(data[i])
          }
        }
        return a;
      },
   
    sortedArray() {
      var vm = this;
      function compare_cheap(a, b) {
        if (a.costs.total_fees < b.costs.total_fees)
          return -1;  
        if (a.costs.total_fees > b.costs.total_fees)
            return 1;
        return 0;
      }
      
      function compare_fast(a, b) {
        if (a.transfer_time_product_rate < b.transfer_time_product_rate)
          return -1;  
        if (a.transfer_time_product_rate > b.transfer_time_product_rate)
          return 1;
        if (a.costs.total_fees < b.costs.total_fees)
          return -1;  
        if (a.costs.total_fees > b.costs.total_fees)
          return 1;
        return 0;
      }

      function compare_best(a, b) {
        if (vm.info.psp_list.find(item => item.id == a.psp_id).reviews.score.global > vm.info.psp_list.find(item => item.id == b.psp_id).reviews.score.global)
          return -1;  
        if (vm.info.psp_list.find(item => item.id == a.psp_id).reviews.score.global < vm.info.psp_list.find(item => item.id == b.psp_id).reviews.score.global)
          return 1;
        if (a.costs.total_fees < b.costs.total_fees)
          return -1;  
        if (a.costs.total_fees > b.costs.total_fees)
          return 1;
        return 0;
      }

      function psp_cheap(a, b) {
        if (a.psp_id < b.psp_id)
          return -1;  
        if (a.psp_id > b.psp_id)
          return 1;
        if (a.costs.total_fees < b.costs.total_fees)
          return -1;  
        if (a.costs.total_fees > b.costs.total_fees)
          return 1;
        return 0;
      }

      function psp_fast(a, b) {
        if (a.psp_id < b.psp_id)
          return -1;  
        if (a.psp_id > b.psp_id)
          return 1;
        if (a.transfer_time_product_rate < b.transfer_time_product_rate)
          return -1;  
        if (a.transfer_time_product_rate > b.transfer_time_product_rate)
          return 1;
        if (a.costs.total_fees < b.costs.total_fees)
          return -1;  
        if (a.costs.total_fees > b.costs.total_fees)
          return 1;
        return 0;
      }

      function psp_best(a, b) {
        if (a.psp_id < b.psp_id)
          return -1;  
        if (a.psp_id > b.psp_id)
          return 1;
        if (a.transfer_time_product_rate < b.transfer_time_product_rate)
          return -1;  
        if (a.transfer_time_product_rate > b.transfer_time_product_rate)
          return 1;
        if (a.costs.total_fees < b.costs.total_fees)
          return -1;  
        if (a.costs.total_fees > b.costs.total_fees)
          return 1;
        return 0;
      }
      

      function onlyScored(data) {
        
        var a = [], prev;
        for ( var i = 0; i < data.length; i++ ) {
          if (vm.info.psp_list.find(item => item.id == data[i].psp_id).reviews.hasOwnProperty("score") == true){
            a.push(data[i])
          }
        }
        return a;
      }

      
      function keep_one_of_each(data) {
  
        var a = [], prev;
        for ( var i = 0; i < data.length; i++ ) {
          if ( data[i].psp_id !== prev ) {
            a.push(data[i])
          }
          prev = data[i].psp_id
        }
        return a;
      }

      function pay_in(data) {
  
        var a = [];
        for ( var i = 0; i < data.length; i++ ) {
          if ( Object.keys(data[i].options.sending)[0] == 'bank_transfer' && vm.bank_transfer == true) {
            a.push(data[i])
          } 
          if ( Object.keys(data[i].options.sending)[0] == 'credit_card' && vm.credit_card == true) {
            a.push(data[i])
          }
          if ( Object.keys(data[i].options.sending)[0] == 'debit_card' && vm.debit_card == true) {
            a.push(data[i])
          }
        }
        return a;
      }

      


      function payout(element, index, array){
        return ( Object.values(element.options.receiving)[0]==vm.pickReceiving); 

      }

      function payin(element, index, array){
        return ( Object.keys(element.options.sending)[0]=='bank_transfer', 'debit_card'); 
      }

      if(this.cheapView == true){
        var cheapList = pay_in(this.info.results.filter(payout).sort(psp_cheap));
        return keep_one_of_each(cheapList).sort(compare_cheap);
         
      } else if(this.fastView == true){
        var fastList = pay_in(this.info.results.filter(payout).sort(psp_fast));
        return keep_one_of_each(fastList).sort(compare_fast);
      } else {
        var bestList = pay_in(this.info.results.filter(payout).sort(psp_best));
        return keep_one_of_each(onlyScored(bestList).sort(compare_best));


      }     
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
    axios
      .get('https://monito.com/v3/searches?country_fromUS&country_to=GB&currency_from=USD&currency_to=GBP&amount=400&locale=en')
      .then(response => (
        this.info = JSON.parse(atob(response.data['d'].reduce((p, n) => p + 'I' + n, '').slice(1))),
        console.log(this.info)
      ))  
    
  },mounted (){
    //this.handleScroll();
  }
}
</script>


  
<style lang="scss">

.choosing_filter {
  width: 100vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100vh;
  -webkit-clip-path: ellipse(0% 0% at 300% 300%);
  clip-path: ellipse(0% 0% at 300% 300%);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100000000;
  background: linear-gradient(90deg, rgba(23,25,28,1) 0%, rgba(23,25,28,0.98) 50%, rgba(23,25,28,0.82) 100%);
  animation: filters_loading 3.2s forwards;
  animation-delay: 2.1s; 

  @keyframes filters_loading {
    from {
      //clip-path: ellipse(0% 100% at 140% 50%);
      -webkit-clip-path: circle(50% at 50% 400%);
      clip-path: circle(50% at 50% 400%);
    
    }

    80% {
      //clip-path: ellipse(100% 100% at 50% 50%);
      clip-path: circle(300% at 49% 80%);
     -webkit-clip-path: circle(300% at 49% 80%);
    }
    to {
      
     //clip-path: ellipse(100% 100% at 50% 50%);
      clip-path: circle(300% at 49% 80%);
      -webkit-clip-path: circle(300% at 49% 80%);
    }
  }

  .container_filters {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }

  .container_filters > .title {
    flex: none;
    display: block;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    color: #fff;
    opacity: 0;
    width: 570px;
    animation: box_filter_appear 0.6s ease-out forwards;
    animation-delay: 3.2s; 

     &:after {
          content: '';
          position: absolute;
          width: 157px;
          height: 87px;
          right: -40px;
          bottom: -60px;
          background-image: url('../assets/arrow_hero_looping.svg');
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
        }

    h1 {
      opacity: 0.86;
      position: relative;
     
    }

    a {
      display: inline-block;
      cursor: pointer;
      &:hover {

      }
    }

    p {
      text-decoration: underline;
      opacity: 0.86;
      &:hover {
        opacity: 1;
        cursor: pointer;
      }
    }
  }
  .container_filters > aside {
    opacity: 0;
    position: relative; 
    animation: box_filter_appear 0.6s ease-out forwards;
    animation-delay: 3.4s; 
    bottom: -20px;
    right: 0;
    top: auto;
    left: auto;
     @keyframes box_filter_appear {
      from {bottom: -20px; opacity: 0}
      to {bottom: 0; opacity: 1}
    }
  }
}

h1 {
  transition: all 1.5s;
  span.label {
    font-weight: 600;
    position: relative;
    font-style: italic;
    font-size: 30px;
    top: 0px;
    color: #f53449;
    cursor: pointer;
  }
}

h2 span:hover {
  text-decoration: underline;
}

h2 span {
  padding-left: 3px;
  padding-right: 3px;
}

main {
  z-index: 1200;
  position: relative;
  margin-right: auto;
  margin-left: auto;
  margin-top: -260px;
}

.story {
  margin-top: 30px;
}

.flip-list-enter-active {
  animation: appear_result 1s forwards; 
}

.apper-enter-active {
  animation: appear_result 1s forwards;
}

.apper-move {
  transition: all 1.5s;
}


@keyframes appear_result {
  from {
    transform: translateY(14px);
    opacity: 0;
  }

  90% {   
    opacity: 1;
  }
  to {
    transform: translateY(0px);
  }
}


@keyframes barre {
  from {
    width: 0
  }
  to {
  }
}

.end-loading-leave-active {
  animation: end-loading 1s forwards;
}

@keyframes end-loading {
  from {
    transform: translateY(0px);
    opacity: 1;
  }

  90% {
    opacity: 0;
  }
  to {
    transform: translateY(14px);
    opacity: 0;
  }
}

.main_content {
  position: relative;
  width: 100%;
}



#app {
  font-family: 'Avenir next', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.active {
  border: 2px blue solid;
}

button:focus {
  outline: none;
}


.story {

  a {
    color: #f53449;
    font-weight: 600;
  }
  padding-bottom: 80px!important;

  h1 {
    width: 600px;
    margin-left: auto;
    margin-right: auto;
    font-size: 28px!important;
    line-height: 38px!important;
    margin-bottom: 60px!important;
  }

  p {
    width: 630px;
    margin-left: auto;
    margin-right: auto;
  }

}

aside{
  z-index: 1000;
  width: 284px;
  position: absolute;
  right: 0;
  top: 50px;

  & > div {
    margin: 20px 0;
    padding: 1px 20px;
    background-color: #fff;
    border-radius: 12px;
    box-sizing: border-box;

    h3 {
      display:block;
      font-size: 16px;
      font-style: italic;
      font-family: 'Avenir Next';
      font-weight: 700;
      letter-spacing: 0.025em;
      margin-top: 25px;
      margin-bottom: 20px;
      text-align: center;
      color: #353C45;
    }
  }
}


.pick_loading {
  width: 362px;
  padding-bottom : 20px;
  border-radius: 12px;
  border: 3px solid rgba(90,89,89,0.09);

  h2 {
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
    background-color: #fff;
    width: 78%;
    color: #353C45;
    margin-left: auto;
    margin-right: auto;
    margin-top: -14px;
    margin-bottom:26px;
    font-size: 21px;
    line-height: 26px;
    letter-spacing: 0.02em;
    font-weight: 700;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-style: italic;
  }

  label {
    font-size: 17px;
    display: block;
    padding-top: 14px;
    padding-bottom: 14px;
    margin-bottom : 8px;
    border-radius: 200px;
    width: 80%;
    color: #51575E;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    cursor: pointer;
    font-weight: 700;
    letter-spacing: 0.026em;
    font-style: italic;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    &:hover {
      background-color: #ededed80 ;
    }

    &.picked {
      cursor: default;
      background-color: #FF9D18;
      color: #fff;
      -webkit-box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.08);
      -moz-box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.08);
      box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.08);
    }
  }

  &.pick_interest_loading {
    label.picked {      
      background-color: #9BCD09;
    }
  }

   &.pick_payout_loading {
    h2 {
      margin-top: -32px;
    }
  }
}

.my_list {
  padding:0;
}


.my_list li a {
    width: 205px;
    padding-left: 20px;
    padding-right: 20px;
    background: #9ccd00;
    border-radius: 8px;
    box-sizing: border-box;
    display: inline-block;
    text-decoration: none;
    font-family: "Avenir Next Medium";
    color: #fff;  
    text-shadow: 0px 1px 3px #00000020;
    -webkit-box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.08);
      -moz-box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.08);
      box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.08);

    font-size: 15px;
    letter-spacing: 0.03em;
    text-align: center;
    padding-top: 15px;
    font-style: italic;
    padding-bottom: 15px;


    &:hover{
      background-color: #00a400;
    }


    span {
      font-family: "Avenir Next";
      font-weight: 700;
      letter-spacing: 0.05em;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale; 
    }
  }

  .my_list li{
    &:after {
    content: '';
    position: absolute;
    height: 1px;
    left: 25px;
    width: calc(100% - 50px);
    bottom: 0;
    background: #efefef;
    }
  }


.my_list > li {
    
    list-style: none;
    box-sizing: border-box;
    position: relative;



    > .container {
      width: 100%;
      box-sizing: border-box;
      padding: 13px 36px;
      overflow: hidden;
      justify-content: space-between;
      display: flex;
      align-items: center;
    }

   

    .details {
      pointer-events:none;

      > .container {
        width: 310px!important;
        background: #2E3238;
        float: right;
        min-height: 380px;        
        border-radius: 12px;
        -webkit-box-shadow: 0px 0px 6px 20px rgba(0,0,0,0.12);
        -moz-box-shadow: 0px 0px 6px 20px rgba(0,0,0,0.12);
        box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.12);
        color: #fff;
        text-align: center;
        padding-bottom: 28px;

        span {
          display: block;
          letter-spacing: 0.031em; 
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;

          &.boxed_info {
            background: #ffffff1c;
            padding: 10px 28px;
            margin: 6px auto;
            border-radius: 10px;
            font-weight: 600;
            font-size: 16px;


            &.clock {
              position: relative;
              padding-left: 48px;
              &:before {
                content: '';
                height: 16px;
                width: 16px;
                position: absolute;
                left: 24px;
                top: 13px;
                background-image: url('../assets/clock_white.svg');
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
              }
            }
          }
        }

        > div:first-of-type {
          margin-bottom: 75px;
          position: relative;
          &:after{
            content: '';
            opacity: 0.6;
            height: 32px;
            width: 12px;
            position: absolute;
            bottom: -52px;
            background-image: url('../assets/arrow_black_box.svg');
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
          }
        }

        > div {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        &:before {
          content: '';
          position: absolute;
          width: 20px;
          height: 50px;
          z-index: 100;
          background: #2E3238;
          top: 165px;
          left: 4px;
        } 

        &:after {
          content: '';
          width: 22px;
          background: #2E3238;
          height: 22px;
          transform: rotate(45deg) skew(13deg,13deg);
          -webkit-box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.08);
          -moz-box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.08);
          box-shadow: 0px 3px 6px 0px rgba(0,0,0,0.08);
          left: -6px;
          top: 178px;
          position: absolute;
        }  
      }
      
      width: 314px!important;
      top: -149px;
      right: -329px;
      opacity: 1;
      position: absolute;
      display:none;
    }

    &:hover {
      .details {
        display: block;
      }
    }
    

    &:last-child {
      &:after {
        display:none;
      }
    }


    
  
    .logo_provider {
      min-width: 150px;
      display: inline-flex;
      align-items: center;
      height: 50px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: right center;
      margin-right: 26px;
    }

    .total_cost {
      border-radius: 7px;
      color: #f53449;
      width: 104px;
      text-align: center;
      font-style: italic;
      font-size: 14px;
      font-family: "Avenir Next";
      font-weight: 600;
      letter-spacing: 0.005em;
      position: relative;
      margin-right: 23px;
      z-index: 10;

      &:after {
        content: '';
        background: #e6e6e64d;
        width: 100%;
        position: absolute;
        top: -60px;
        left: 0;
        z-index: -1;
        height: 200px;
      }
    }
     .amount {
      font-size: 23px;
      font-family: "Avenir Next";
      font-weight: 700;
      margin-left: 22px;
      margin-right: 22px;
      white-space: nowrap;
      position: relative;
    }

    .container_amount {
      align-items: center;
      display: inline-flex;
      flex: 1;
      
      .illustration_amount {
        width: 100%;
        overflow: hidden;
        
        display: inline-flex;
        height: 31px;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 0 30px 30px 0;

        .anim_element {
          box-sizing: border-box;
          padding-left: 18px;
          background-color: #f00;
          //opacity: 0;left: -100px;
          position: relative;
          border-radius: 0 30px 30px 0;
          &.anime {
            @keyframes opacity_value {
              0% {opacity: 0;left: -200px;}
              100% { opacity: 1;left: 0;}
            }
              animation-name: opacity_value;
              animation-duration: 1.9s;
              animation-fill-mode: forwards;
          }
        }
      } 
    }

    &.excellent {
                &:hover {
                    background: rgba(0,160,0,0.1);
                    cursor: default; 
                }
                .container_amount .illustration_amount .anim_element {
                    background:rgb(0,160,0)!important;
                }
            }

            &.good {
                &:hover {
                    
                    background: rgba(118,193,7,0.1);
                    cursor: default; 
                }

                .container_amount .illustration_amount .anim_element {
                    background:rgb(118,193,7)!important;
                }
            }

            &.average {
                &:hover {
                    background: rgba(255,154,0,0.1);
                    cursor: default; 
                }
                .container_amount .illustration_amount .anim_element {
                    background:rgb(255,154,0)!important;
                }
            }

            &.poor {
                &:hover {
                    background: rgba(255,88,0,0.1);
                    cursor: default; 
                }
                .container_amount .illustration_amount .anim_element {
                    background:rgb(255,88,0)!important;
                }
            }

            &.bad {
                &:hover {
                    background: rgba(255,0,48,0.1);
                    cursor: default; 
                }
                .container_amount .illustration_amount .anim_element {
                    background:rgb(255,0,48)!important;
                }
            }
}

.cheap_list li {
  &:first-child > .container {
      border: 3px solid #79CA0C;
      margin: 0 16px; 
      padding-left: 17px;
      padding-right: 17px;
      border-radius: 10px;
      overflow: visible;
      margin-bottom: 4px;
      width: calc(100% - 32px);

      .total_cost {
        background: #e6e6e64d;
        border-radius: 8px;
        padding-top: 20px;
        padding-bottom: 20px;
        &:after {
          display: none;
        }
        &:before {
          content:'Total cost';
          top: -46px;
          font-size: 15px;
          position: absolute;
          display: inline-block;
          width: 130%;
          left: -15%;
        }
      }

      &:before {
        content: 'Cheapest';
        text-transform: uppercase;
        display: inline-block;
        position : absolute;
        background-color: #fff;
        background-size: 3px auto;

        letter-spacing: 0.07em;
        font-weight: 700;
        font-size: 14px;
        padding: 0 16px;
        top: -10px;
        left: 25px;
        color: #79CA0C;
      }
    }
     &:nth-child(2) {
      .total_cost {
        &:after {
          top: -28px;
          border-radius: 8px;
        }
      }
    }

    &:first-child {

      &:after {
        display:none;
      }
    }
}


.container_picker {
  display: flex;
  margin-bottom: 60px;
  margin-left: 55px;
  margin-right: 55px;
  margin-top: 60px;
  justify-content: space-between;
  align-items: center;  
}



input[type="radio"] {
  display: none;
}

.result {
  padding-bottom: 6px;
  overflow: visible; 
  min-height: 400px;
  background: #fff;
  z-index: 20000;
  border-radius: 20px;
  position: relative;
  width: 886px;
  transition: all 1.5s;

  h1 {
    font-size: 38px;
    text-align: center;
    max-width: 740px;
    margin-left: auto;
    margin-right: auto;
    line-height: 48px;
    letter-spacing: 0.02em;
  }
}



.before_result {
  margin-left: auto;
  margin-right: auto;
  margin-top: 100px;
}


.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}

// Avenir Next Regular

@font-face {
  font-family: 'Monito';
  src: local('Avenir Next'),
    ('/_comp/fonts/avenir/7db1f672-3a8f-4d19-9c49-7f61aed450b5-1560902400.woffurl2') format('woff2'),
    url('/_comp/fonts/avenir/4ab86b35-c0c2-42b5-98ad-4b6eba66b197-1560902400.woff') format('woff');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

// Avenir Next Demi Bold

@font-face {
  font-family: 'Monito';
  src: local('Avenir Next'),
    url('/_comp/fonts/avenir/40d36b4a-60c6-460a-bf43-4c948c23563e-1560902400.woff2') format('woff2'),
    url('/_comp/fonts/avenir/45b78f45-e639-4836-8612-e0892e120f14-1560902400.woff') format('woff');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

// Avenir Next Bold

@font-face {
  font-family: 'Monito';
  src: local('Avenir Next'),
    url('/_comp/fonts/avenir/4c04fb14-abdb-4f93-82bb-734d1b84307b-1560902400.woff2') format('woff2'),
    url('/_comp/fonts/avenir/04d2f223-2786-40c9-8481-be9dd47d8e7f-1560902400.woff') format('woff');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}





</style>



// WEBPACK FOOTER //
// src/components/Corridor.vue